import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { ToolsIndex } from "../components/tools/ToolsIndex";
import { siteLangOf } from "../lib/marketing/registry";
import { documentHeaders } from "../lib/seo";
import { toolsIndexHead } from "../lib/tools/head";
import {
  loadToolCopy,
  TOOLS,
  toolPath,
  toolsIndexPath,
} from "../lib/tools/index";
import { TOOLS_UI } from "../lib/tools/ui";

/**
 * The tools hub in a non-English language, at `/<lang>/tools`.
 *
 * Same redirect rule as the tool pages and the landing page: a segment that
 * resolves to a language whose canonical path is not the one requested is a
 * 301, not a second live URL.
 */
export const Route = createFileRoute("/$lang/tools/")({
  loader: async ({ params }) => {
    const lang = siteLangOf(params.lang);
    if (!lang) throw notFound();

    const path = toolsIndexPath(lang);
    if (path !== `/${params.lang}/tools`)
      throw redirect({ href: path, statusCode: 301 });

    return { lang, copy: await loadToolCopy(lang) };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? toolsIndexHead(
          loaderData.lang,
          TOOLS_UI[loaderData.lang],
          TOOLS.map((tool) => ({
            name: loaderData.copy[tool.slug].h1,
            path: toolPath(tool.slug, loaderData.lang),
          })),
        )
      : {},
  component: LocalizedToolsIndex,
});

function LocalizedToolsIndex() {
  const { lang, copy } = Route.useLoaderData();
  return <ToolsIndex lang={lang} ui={TOOLS_UI[lang]} copy={copy} />;
}
